// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_la-0";
export var buttonContainer = "_la-3";
export var cancelButton = "_la-4";
export var headerSection = "_la-6";
export var headerTitle = "_la-9";
export var messageSideLeft = "_la-1";
export var messageSideRight = "_la-2";
export var orderNumberContainer = "_la-7";
export var orderNumberLabel = "_la-8";
export var submitButton = "_la-5";